// extracted by mini-css-extract-plugin
export default {"wrapper":"eI","noPadding":"fI","flavor_wrapper":"gI","flavor_button":"hI","vert":"iI","itemContent":"jI","itemName":"kI","blue":"lI","out_of_stock":"mI","newFlavorBadge":"nI","fullWidth":"oI","flavor_button_selected":"pI","black":"qI","attribute_wrapper":"rI","toggle_wrapper":"sI"};
    if(module.hot) {
      // 1737143662143
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  